<template>
<div ref="DataHistory" class="dialog-container">
<div class="dialog scroll" style="transform: translate(0, -300px); max-width: 780px; max-height: 680px;">
<form @submit.stop="doValidation()">
<div class="center dialog-flex" style="margin: 0;">
<div style="width: 100%;">
<span class="dialog-tag">데이터 기록</span>

<!-- 기간 필터 토글 -->
<div class="period-filter">
<button
v-for="p in periodOptions"
:key="p.value"
type="button"
:class="['period-btn', { 'period-btn-on': selectedPeriod === p.value }]"
@click="changePeriod(p.value)"
>{{ p.label }}</button>
</div>

<!-- 데이터 없을 때 -->
<div class="none-list" style="border-top: none;" v-if="filteredList.length === 0">
데이터 기록이 없습니다.
</div>

<!-- 차트 영역 -->
<div v-if="filteredList.length > 0">

	<!-- 체중 차트 -->
	<div v-if="weightData.length > 0" class="chart-block">
		<div class="chart-title">체중 (kg)</div>
		<canvas ref="weightChart" height="100"></canvas>
		<button type="button" class="toggle-table-btn" @click="toggleTable('WEIGHT')">{{ tableOpen['WEIGHT'] ? '▲ 상세 데이터 접기' : '▼ 상세 데이터 보기' }}</button>
		<div v-show="tableOpen['WEIGHT']">
			<table class="tb-crud-horizon popup-table" style="margin-top: 8px;">
				<colgroup><col width="auto" /><col width="180px" /></colgroup>
				<tbody>
					<tr style="border-top: 1px solid #191C26"><th>수치 (kg)</th><th>측정 일시</th></tr>
					<tr v-for="(d, i) in weightData" :key="i" class="history-tr">
						<td>{{ d.value }}</td>
						<td>{{ d.recordDetailDate.substring(0, 19) }}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>

	<!-- 혈압 차트 -->
	<div v-if="bloodPressureData.length > 0" class="chart-block">
		<div class="chart-title">혈압 (mmHg)</div>
		<canvas ref="bpChart" height="100"></canvas>
		<button type="button" class="toggle-table-btn" @click="toggleTable('BLOOD_PRESSURE')">{{ tableOpen['BLOOD_PRESSURE'] ? '▲ 상세 데이터 접기' : '▼ 상세 데이터 보기' }}</button>
		<div v-show="tableOpen['BLOOD_PRESSURE']">
			<table class="tb-crud-horizon popup-table" style="margin-top: 8px;">
				<colgroup><col width="auto" /><col width="180px" /></colgroup>
				<tbody>
					<tr style="border-top: 1px solid #191C26"><th>수축기/이완기 (mmHg)</th><th>측정 일시</th></tr>
					<tr v-for="(d, i) in bloodPressureData" :key="i" class="history-tr">
						<td>{{ d.value }}/{{ d.subValue }}</td>
						<td>{{ d.recordDetailDate.substring(0, 19) }}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>

	<!-- 혈당 차트 -->
	<div v-if="bloodGlucoseData.length > 0" class="chart-block">
		<div class="chart-title">혈당 (mg/dL)</div>
		<canvas ref="bgChart" height="100"></canvas>
		<button type="button" class="toggle-table-btn" @click="toggleTable('BLOOD_GLUCOSE')">{{ tableOpen['BLOOD_GLUCOSE'] ? '▲ 상세 데이터 접기' : '▼ 상세 데이터 보기' }}</button>
		<div v-show="tableOpen['BLOOD_GLUCOSE']">
			<table class="tb-crud-horizon popup-table" style="margin-top: 8px;">
				<colgroup><col width="auto" /><col width="180px" /></colgroup>
				<tbody>
					<tr style="border-top: 1px solid #191C26"><th>수치 (mg/dL)</th><th>측정 일시</th></tr>
					<tr v-for="(d, i) in bloodGlucoseData" :key="i" class="history-tr">
						<td>{{ d.value }}</td>
						<td>{{ d.recordDetailDate.substring(0, 19) }}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>

	<!-- 심박수 차트 -->
	<div v-if="heartRateData.length > 0" class="chart-block">
		<div class="chart-title">심박수 (bpm)</div>
		<canvas ref="hrChart" height="100"></canvas>
		<button type="button" class="toggle-table-btn" @click="toggleTable('HEART_RATE')">{{ tableOpen['HEART_RATE'] ? '▲ 상세 데이터 접기' : '▼ 상세 데이터 보기' }}</button>
		<div v-show="tableOpen['HEART_RATE']">
			<table class="tb-crud-horizon popup-table" style="margin-top: 8px;">
				<colgroup><col width="auto" /><col width="180px" /></colgroup>
				<tbody>
					<tr style="border-top: 1px solid #191C26"><th>수치 (bpm)</th><th>측정 일시</th></tr>
					<tr v-for="(d, i) in heartRateData" :key="i" class="history-tr">
						<td>{{ d.value }}</td>
						<td>{{ d.recordDetailDate.substring(0, 19) }}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>

	<!-- 걸음수 차트 -->
	<div v-if="stepCountData.length > 0" class="chart-block">
		<div class="chart-title">걸음수 (보)</div>
		<canvas ref="stepChart" height="100"></canvas>
		<button type="button" class="toggle-table-btn" @click="toggleTable('STEP_COUNT')">{{ tableOpen['STEP_COUNT'] ? '▲ 상세 데이터 접기' : '▼ 상세 데이터 보기' }}</button>
		<div v-show="tableOpen['STEP_COUNT']">
			<table class="tb-crud-horizon popup-table" style="margin-top: 8px;">
				<colgroup><col width="auto" /><col width="180px" /></colgroup>
				<tbody>
					<tr style="border-top: 1px solid #191C26"><th>수치 (보)</th><th>측정 일시</th></tr>
					<tr v-for="(d, i) in stepCountData" :key="i" class="history-tr">
						<td>{{ d.value }}</td>
						<td>{{ d.recordDetailDate.substring(0, 19) }}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>

	<!-- 칼로리 차트 -->
	<div v-if="calorieData.length > 0" class="chart-block">
		<div class="chart-title">칼로리 (kcal)</div>
		<canvas ref="calChart" height="100"></canvas>
		<button type="button" class="toggle-table-btn" @click="toggleTable('CALORIE')">{{ tableOpen['CALORIE'] ? '▲ 상세 데이터 접기' : '▼ 상세 데이터 보기' }}</button>
		<div v-show="tableOpen['CALORIE']">
			<table class="tb-crud-horizon popup-table" style="margin-top: 8px;">
				<colgroup><col width="auto" /><col width="180px" /></colgroup>
				<tbody>
					<tr style="border-top: 1px solid #191C26"><th>수치 (kcal)</th><th>측정 일시</th></tr>
					<tr v-for="(d, i) in calorieData" :key="i" class="history-tr">
						<td>{{ d.value }}</td>
						<td>{{ d.recordDetailDate.substring(0, 19) }}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>

	<!-- 산소포화도 차트 -->
	<div v-if="oxygenData.length > 0" class="chart-block">
		<div class="chart-title">산소포화도 (%)</div>
		<canvas ref="o2Chart" height="100"></canvas>
		<button type="button" class="toggle-table-btn" @click="toggleTable('OXYGEN_SATURATION')">{{ tableOpen['OXYGEN_SATURATION'] ? '▲ 상세 데이터 접기' : '▼ 상세 데이터 보기' }}</button>
		<div v-show="tableOpen['OXYGEN_SATURATION']">
			<table class="tb-crud-horizon popup-table" style="margin-top: 8px;">
				<colgroup><col width="auto" /><col width="180px" /></colgroup>
				<tbody>
					<tr style="border-top: 1px solid #191C26"><th>수치 (%)</th><th>측정 일시</th></tr>
					<tr v-for="(d, i) in oxygenData" :key="i" class="history-tr">
						<td>{{ d.value }}</td>
						<td>{{ d.recordDetailDate.substring(0, 19) }}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>

	<!-- 스트레스 차트 -->
	<div v-if="stressData.length > 0" class="chart-block">
		<div class="chart-title">스트레스 지수</div>
		<canvas ref="stressChart" height="100"></canvas>
		<button type="button" class="toggle-table-btn" @click="toggleTable('STRESS')">{{ tableOpen['STRESS'] ? '▲ 상세 데이터 접기' : '▼ 상세 데이터 보기' }}</button>
		<div v-show="tableOpen['STRESS']">
			<table class="tb-crud-horizon popup-table" style="margin-top: 8px;">
				<colgroup><col width="auto" /><col width="180px" /></colgroup>
				<tbody>
					<tr style="border-top: 1px solid #191C26"><th>지수</th><th>측정 일시</th></tr>
					<tr v-for="(d, i) in stressData" :key="i" class="history-tr">
						<td>{{ d.value }}</td>
						<td>{{ d.recordDetailDate.substring(0, 19) }}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>

	<!-- 수면시간 차트 -->
	<div v-if="sleepData.length > 0" class="chart-block">
		<div class="chart-title">수면시간 (시간)</div>
		<canvas ref="sleepChart" height="100"></canvas>
		<button type="button" class="toggle-table-btn" @click="toggleTable('SLEEP_TIME')">{{ tableOpen['SLEEP_TIME'] ? '▲ 상세 데이터 접기' : '▼ 상세 데이터 보기' }}</button>
		<div v-show="tableOpen['SLEEP_TIME']">
			<table class="tb-crud-horizon popup-table" style="margin-top: 8px;">
				<colgroup><col width="auto" /><col width="180px" /></colgroup>
				<tbody>
					<tr style="border-top: 1px solid #191C26"><th>수면시간</th><th>측정 일시</th></tr>
					<tr v-for="(d, i) in sleepData" :key="i" class="history-tr">
						<td>{{ getSleepTime(d.value) }}</td>
						<td>{{ d.recordDetailDate.substring(0, 19) }}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>

	<!-- 단백뇨 차트 -->
	<div v-if="proteinuriaData.length > 0" class="chart-block">
		<div class="chart-title">
			<div>단백뇨 등급</div>
			<div class="chart-legend-note">1: 0mg/L &nbsp;&nbsp; 2: 15-30mg/L &nbsp;&nbsp; 3: 30mg/L &nbsp;&nbsp; 4: 100mg/L &nbsp;&nbsp; 5: 300mg/L &nbsp;&nbsp; 6: 1000mg/L 이상</div>
		</div>
		<canvas ref="protChart" height="100"></canvas>
		<button type="button" class="toggle-table-btn" @click="toggleTable('PROTEINURIA')">{{ tableOpen['PROTEINURIA'] ? '▲ 상세 데이터 접기' : '▼ 상세 데이터 보기' }}</button>
		<div v-show="tableOpen['PROTEINURIA']">
			<table class="tb-crud-horizon popup-table" style="margin-top: 8px;">
				<colgroup><col width="auto" /><col width="180px" /></colgroup>
				<tbody>
					<tr style="border-top: 1px solid #191C26"><th>등급</th><th>측정 일시</th></tr>
					<tr v-for="(d, i) in proteinuriaData" :key="i" class="history-tr">
						<td>
							<span v-if="d.value == 0">미선택</span>
						<span v-if="d.value == 1">0 mg/L</span>
							<span v-if="d.value == 2">15-30 mg/L</span>
							<span v-if="d.value == 3">30 mg/L</span>
							<span v-if="d.value == 4">100 mg/L</span>
							<span v-if="d.value == 5">300 mg/L</span>
							<span v-if="d.value == 6">1000 mg/L 이상</span>
						</td>
						<td>{{ d.recordDetailDate.substring(0, 19) }}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>

</div>

					</div>
				</div>
				<div class="bottom" style="display: flex; justify-content: center; column-gap: 10px;">
					<button type="button" class="btn-cancel" style="margin: 0;" title="Cancel" @click="doCancel()">
						닫기
					</button>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
import axios from "axios";
import EventBus from "@/script/EventBus.js";
import moment from "moment";
import Chart from "chart.js";

export default {
	name: "DataHistory",
	created() {
		this.logger.debug(this, "created()");
		this.selectDataHistoryList();
	},
	data() {
		return {
			item: {
				id: "",
				name: "",
				userId: sessionStorage.getItem('userId'),
				userName: sessionStorage.getItem('userName'),
				recordType : "",
				status: "",
				alarmContents: "",
				repeatCnt: 0
			},
			isTab: 1,
			dataList: [],
			selectedPeriod: 7,
			periodOptions: [
				{ label: '7일', value: 7 },
				{ label: '14일', value: 14 },
				{ label: '30일', value: 30 },
				{ label: '전체', value: 0 },
			],
			isTableOpen: false,
			tableOpen: {},
			chartWeight: null,
			chartBp: null,
			chartBg: null,
		chartHr: null,
		chartStep: null,
		chartCal: null,
		chartO2: null,
		chartStress: null,
		chartSleep: null,
		chartProt: null,
		};
	},
	computed: {
		filteredList() {
			if (this.selectedPeriod === 0) return this.dataList;
			const cutoff = moment().subtract(this.selectedPeriod, 'days').startOf('day');
			return this.dataList.filter(d => moment(d.recordDetailDate).isSameOrAfter(cutoff));
		},
		weightData() {
			return this.filteredList.filter(d => d.recordType === 'WEIGHT').sort((a,b) => a.recordDetailDate.localeCompare(b.recordDetailDate));
		},
		bloodPressureData() {
			return this.filteredList.filter(d => d.recordType === 'BLOOD_PRESSURE').sort((a,b) => a.recordDetailDate.localeCompare(b.recordDetailDate));
		},
		bloodGlucoseData() {
			return this.filteredList.filter(d => d.recordType === 'BLOOD_GLUCOSE').sort((a,b) => a.recordDetailDate.localeCompare(b.recordDetailDate));
		},
		heartRateData() {
			return this.filteredList.filter(d => d.recordType === 'HEART_RATE').sort((a,b) => a.recordDetailDate.localeCompare(b.recordDetailDate));
		},
		stepCountData() {
			return this.filteredList.filter(d => d.recordType === 'STEP_COUNT').sort((a,b) => a.recordDetailDate.localeCompare(b.recordDetailDate));
		},
		calorieData() {
			return this.filteredList.filter(d => d.recordType === 'CALORIE').sort((a,b) => a.recordDetailDate.localeCompare(b.recordDetailDate));
		},
		oxygenData() {
			return this.filteredList.filter(d => d.recordType === 'OXYGEN_SATURATION').sort((a,b) => a.recordDetailDate.localeCompare(b.recordDetailDate));
		},
		stressData() {
			return this.filteredList.filter(d => d.recordType === 'STRESS').sort((a,b) => a.recordDetailDate.localeCompare(b.recordDetailDate));
		},
		sleepData() {
			return this.filteredList.filter(d => d.recordType === 'SLEEP_TIME').sort((a,b) => a.recordDetailDate.localeCompare(b.recordDetailDate));
		},
		proteinuriaData() {
			return this.filteredList.filter(d => d.recordType === 'PROTEINURIA').sort((a,b) => a.recordDetailDate.localeCompare(b.recordDetailDate));
		},
	},
	watch: {
		filteredList() {
			this.$nextTick(() => {
				this.renderCharts();
			});
		},
	},
	components:{
	},
	props: {
		selectData: {
			type: Object,
			required: true
		},
	},
	methods: {
		doValidation() {
			this.logger.debug(this, "doValidation()");
			this.$validator
				.validateAll()
				.then((result) => {
					this.logger.debug(this, "doValidationResult:" + result);
					if (result) {
						this.$confirm("Do you want to register the current Question Group?", "Question", "question").then(() => {
							EventBus.$emit("field-loading", true);
							this.doInsert();
						});
					}
				})
				.catch(() => {
					this.logger.debug(this, "-->" + this.errors.all());
					alert(this.errors.all());
					return false;
				});
		},
		selectDataHistoryList() {
			this.logger.debug(this, "selectDataHistoryList()");
			axios
				.post(this.config.contextRoot + "/collectData/selectDataHistoryList.do", this.selectData)
				.then((response) => {
					console.log(response);
					this.dataList = response.data.dataList;
					EventBus.$emit("project-loading", false);
					this.$nextTick(() => {
						this.renderCharts();
					});
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		changePeriod(val) {
			this.selectedPeriod = val;
		},
		toggleTable(type) {
			this.$set(this.tableOpen, type, !this.tableOpen[type]);
		},
		renderCharts() {
			this.renderWeightChart();
			this.renderBpChart();
			this.renderBgChart();
			this.renderHrChart();
			this.renderStepChart();
			this.renderCalChart();
			this.renderO2Chart();
			this.renderStressChart();
			this.renderSleepChart();
			this.renderProtChart();
		},
		renderWeightChart() {
			if (!this.$refs.weightChart) return;
			if (this.chartWeight) { this.chartWeight.destroy(); this.chartWeight = null; }
			if (this.weightData.length === 0) return;
			const sorted = this.weightData.slice();
			const labels = sorted.map(d => d.recordDetailDate.substring(5, 16));
			const values = sorted.map(d => parseFloat(d.value));
			this.chartWeight = new Chart(this.$refs.weightChart, {
				type: 'line',
				data: {
					labels: labels,
					datasets: [{
						label: '체중 (kg)',
						data: values,
						borderColor: '#1A7AFF',
						backgroundColor: 'rgba(26,122,255,0.08)',
						pointBackgroundColor: '#1A7AFF',
						borderWidth: 2,
						fill: true,
						tension: 0.3,
					}]
				},
				options: {
					responsive: true,
					legend: { display: false },
					scales: {
						xAxes: [{ ticks: { maxRotation: 45, minRotation: 30, fontSize: 11 } }],
						yAxes: [{ ticks: { fontSize: 11 } }]
					},
					tooltips: { mode: 'index', intersect: false },
				}
			});
		},
		renderBpChart() {
			if (!this.$refs.bpChart) return;
			if (this.chartBp) { this.chartBp.destroy(); this.chartBp = null; }
			if (this.bloodPressureData.length === 0) return;
			const sorted = this.bloodPressureData.slice();
			const labels = sorted.map(d => d.recordDetailDate.substring(5, 16));
			const systolic = sorted.map(d => parseFloat(d.value));
			const diastolic = sorted.map(d => parseFloat(d.subValue));
			this.chartBp = new Chart(this.$refs.bpChart, {
				type: 'line',
				data: {
					labels: labels,
					datasets: [
						{
							label: '수축기 (mmHg)',
							data: systolic,
							borderColor: '#F94848',
							backgroundColor: 'rgba(249,72,72,0.05)',
							pointBackgroundColor: '#F94848',
							borderWidth: 2,
							fill: false,
						},
						{
							label: '이완기 (mmHg)',
							data: diastolic,
							borderColor: '#22C55E',
							backgroundColor: 'rgba(34,197,94,0.05)',
							pointBackgroundColor: '#22C55E',
							borderWidth: 2,
							fill: false,
						}
					]
				},
				options: {
					responsive: true,
					legend: { display: true, position: 'top', labels: { fontSize: 11, boxWidth: 12 } },
					scales: {
						xAxes: [{ ticks: { maxRotation: 45, minRotation: 30, fontSize: 11 } }],
						yAxes: [{ ticks: { fontSize: 11 } }]
					},
					tooltips: { mode: 'index', intersect: false },
				}
			});
		},
		renderBgChart() {
			if (!this.$refs.bgChart) return;
			if (this.chartBg) { this.chartBg.destroy(); this.chartBg = null; }
			if (this.bloodGlucoseData.length === 0) return;
			const sorted = this.bloodGlucoseData.slice();
			const labels = sorted.map(d => d.recordDetailDate.substring(5, 16));
			const values = sorted.map(d => parseFloat(d.value));
			this.chartBg = new Chart(this.$refs.bgChart, {
				type: 'line',
				data: {
					labels: labels,
					datasets: [{
						label: '혈당 (mg/dL)',
						data: values,
						borderColor: '#FFAD09',
						backgroundColor: 'rgba(255,173,9,0.08)',
						pointBackgroundColor: '#FFAD09',
						borderWidth: 2,
						fill: true,
						tension: 0.3,
					}]
				},
				options: {
					responsive: true,
					legend: { display: false },
					annotation: {
						annotations: [{
							type: 'line',
							mode: 'horizontal',
							scaleID: 'y-axis-0',
							value: 100,
							borderColor: 'rgba(249,72,72,0.5)',
							borderWidth: 1,
							borderDash: [4, 4],
							label: { enabled: true, content: '정상 상한 100', fontSize: 10 }
						}]
					},
					scales: {
						xAxes: [{ ticks: { maxRotation: 45, minRotation: 30, fontSize: 11 } }],
						yAxes: [{ ticks: { fontSize: 11 } }]
					},
					tooltips: { mode: 'index', intersect: false },
				}
			});
		},
		// 공통 단순 꺾은선 차트 생성 헬퍼
		makeLineChart(canvasRef, label, labels, values, color, bgColor) {
			return new Chart(canvasRef, {
				type: 'line',
				data: {
					labels: labels,
					datasets: [{
						label: label,
						data: values,
						borderColor: color,
						backgroundColor: bgColor || 'rgba(0,0,0,0)',
						pointBackgroundColor: color,
						borderWidth: 2,
						fill: true,
					}]
				},
				options: {
					responsive: true,
					legend: { display: false },
					scales: {
						xAxes: [{ ticks: { maxRotation: 45, minRotation: 30, fontSize: 11 } }],
						yAxes: [{ ticks: { fontSize: 11 } }]
					},
					tooltips: { mode: 'index', intersect: false },
				}
			});
		},
		renderHrChart() {
			if (!this.$refs.hrChart) return;
			if (this.chartHr) { this.chartHr.destroy(); this.chartHr = null; }
			if (this.heartRateData.length === 0) return;
			const sorted = this.heartRateData.slice();
			const labels = sorted.map(d => d.recordDetailDate.substring(5, 16));
			const values = sorted.map(d => parseFloat(d.value));
			this.chartHr = this.makeLineChart(this.$refs.hrChart, '심박수 (bpm)', labels, values, '#E040FB', 'rgba(224,64,251,0.08)');
		},
		renderStepChart() {
			if (!this.$refs.stepChart) return;
			if (this.chartStep) { this.chartStep.destroy(); this.chartStep = null; }
			if (this.stepCountData.length === 0) return;
			const sorted = this.stepCountData.slice();
			const labels = sorted.map(d => d.recordDetailDate.substring(5, 16));
			const values = sorted.map(d => parseFloat(d.value));
			this.chartStep = this.makeLineChart(this.$refs.stepChart, '걸음수 (보)', labels, values, '#00BCD4', 'rgba(0,188,212,0.08)');
		},
		renderCalChart() {
			if (!this.$refs.calChart) return;
			if (this.chartCal) { this.chartCal.destroy(); this.chartCal = null; }
			if (this.calorieData.length === 0) return;
			const sorted = this.calorieData.slice();
			const labels = sorted.map(d => d.recordDetailDate.substring(5, 16));
			const values = sorted.map(d => parseFloat(d.value));
			this.chartCal = this.makeLineChart(this.$refs.calChart, '칼로리 (kcal)', labels, values, '#FF7043', 'rgba(255,112,67,0.08)');
		},
		renderO2Chart() {
			if (!this.$refs.o2Chart) return;
			if (this.chartO2) { this.chartO2.destroy(); this.chartO2 = null; }
			if (this.oxygenData.length === 0) return;
			const sorted = this.oxygenData.slice();
			const labels = sorted.map(d => d.recordDetailDate.substring(5, 16));
			const values = sorted.map(d => parseFloat(d.value));
			this.chartO2 = this.makeLineChart(this.$refs.o2Chart, '산소포화도 (%)', labels, values, '#26C6DA', 'rgba(38,198,218,0.08)');
		},
		renderStressChart() {
			if (!this.$refs.stressChart) return;
			if (this.chartStress) { this.chartStress.destroy(); this.chartStress = null; }
			if (this.stressData.length === 0) return;
			const sorted = this.stressData.slice();
			const labels = sorted.map(d => d.recordDetailDate.substring(5, 16));
			const values = sorted.map(d => parseFloat(d.value));
			this.chartStress = this.makeLineChart(this.$refs.stressChart, '스트레스 지수', labels, values, '#7E57C2');
		},
		renderSleepChart() {
			if (!this.$refs.sleepChart) return;
			if (this.chartSleep) { this.chartSleep.destroy(); this.chartSleep = null; }
			if (this.sleepData.length === 0) return;
			const sorted = this.sleepData.slice();
			const labels = sorted.map(d => d.recordDetailDate.substring(5, 16));
			const values = sorted.map(d => Math.min(Math.round((d.value / (1000 * 60 * 60)) * 10) / 10, 24));
			this.chartSleep = new Chart(this.$refs.sleepChart, {
				type: 'bar',
				data: {
					labels: labels,
					datasets: [{
						label: '수면시간 (시간)',
						data: values,
						backgroundColor: 'rgba(63,81,181,0.6)',
						borderColor: '#3F51B5',
						borderWidth: 1,
					}]
				},
				options: {
					responsive: true,
					legend: { display: false },
					scales: {
						xAxes: [{ ticks: { maxRotation: 45, minRotation: 30, fontSize: 11 } }],
						yAxes: [{ ticks: { fontSize: 11, callback: v => v + 'h' } }]
					},
					tooltips: {
						callbacks: {
							label: (item) => '수면: ' + item.yLabel + '시간'
						}
					},
				}
			});
		},
		renderProtChart() {
			if (!this.$refs.protChart) return;
			if (this.chartProt) { this.chartProt.destroy(); this.chartProt = null; }
			if (this.proteinuriaData.length === 0) return;
			const sorted = this.proteinuriaData.filter(d => d.value != 0).slice();
			if (sorted.length === 0) return;
			const labels = sorted.map(d => d.recordDetailDate.substring(5, 16));
			const values = sorted.map(d => parseInt(d.value));
			const gradeColors = ['', '#22C55E','#A3E635','#FACC15','#FB923C','#F87171','#EF4444'];
			this.chartProt = new Chart(this.$refs.protChart, {
				type: 'bar',
				data: {
					labels: labels,
					datasets: [{
						label: '단백뇨 등급',
						data: values,
						backgroundColor: values.map(v => gradeColors[v] || '#ccc'),
						borderColor: values.map(v => gradeColors[v] || '#ccc'),
						borderWidth: 1,
					}]
				},
				options: {
					responsive: true,
					legend: { display: false },
					scales: {
						xAxes: [{ ticks: { maxRotation: 45, minRotation: 30, fontSize: 11 } }],
						yAxes: [{ ticks: { min: 0, max: 6, stepSize: 1, fontSize: 11 } }]
					},
					tooltips: {
						callbacks: {
							label: (item) => {
								const gradeLabel = ['','0 mg/L','15-30 mg/L','30 mg/L','100 mg/L','300 mg/L','1000 mg/L 이상'];
								return '등급 ' + item.yLabel + ': ' + (gradeLabel[item.yLabel] || '');
							}
						}
					},
				}
			});
		},
		doCancel() {
			this.logger.debug(this, "doCancel()");
			this.$confirm("취소하시겠습니까?", "Question", "question").then(() => {
				this.doClose();
			});
		},
		doClose() {
			this.logger.debug(this, "doClose()");
			[this.chartWeight, this.chartBp, this.chartBg, this.chartHr,
			 this.chartStep, this.chartCal, this.chartO2,
			 this.chartStress, this.chartSleep, this.chartProt
			].forEach(c => { if (c) c.destroy(); });
			this.$refs.DataHistory.style.animation = "fadeOut 0.4s ease-in-out both";
			this.$refs.DataHistory.children[0].style.animation = "fadeOutDrop 0.4s ease-in-out both";
			setTimeout(function() {
				this.$parent.isOpenHistory = false;
			}.bind(this), 410);
		},
		changeTap(type) {
			this.isTab = type;
		},
		statusColor(status) {
			var result = "green";
			if (status == 'EMERGENCY') result = 'red';
			if (status == 'CAUTION') result = 'yellow';
			return result;
		},
		getRecordType(recordType) {
			const map = {
				WEIGHT: '체중', BLOOD_PRESSURE: '혈압', BLOOD_GLUCOSE: '혈당',
				HEART_RATE: '심박수', STEP_COUNT: '걸음수', CALORIE: '칼로리',
				PROTEINURIA: '단백뇨', OXYGEN_SATURATION: '산소포화도',
				STRESS: '스트레스', SLEEP_TIME: '수면시간'
			};
			return map[recordType] || recordType;
		},
		getStatusType(status) {
			if (status == 'EMERGENCY') return '경고';
			if (status == 'CAUTION') return '주의';
			return '정상';
		},
		getSleepTime(ms) {
			var hour = String(Math.floor((ms / (1000*60*60)) % 24)).padStart(2, "0");
			var min = String(Math.floor((ms / (1000*60)) % 60)).padStart(2, "0");
			var sec = String(Math.floor((ms / (1000)) % 60)).padStart(2, "0");
			return hour + ':' + min + ':' + sec;
		}
	}
};
</script>

<style>
.btn-cancel {
    margin-right: 10px;
}
.popup-table th {
    background-color: #F8F9FB;
}
.popup-table tr:first-child > th {
    border-top: 1px solid #191C26;
}
.popup-table tr:first-child > td {
    border-top: 1px solid #191C26;
}
.popup-table td {
    border-left: 1px solid #ddd;
    border-right: 1px solid #ddd;
}
.popup-table td:last-child {
    border-right: none;
}
.history-tr > td:first-child {
    border-left: none;
}
.dialog-tag {
    font-size: 18px;
    font-weight: bold;
}
.dialog-flex {
    display: flex;
    column-gap: 40px;
    justify-content: space-between;
}
.dialog-flex > div {
    width: 100%;
}
/* 기간 필터 */
.period-filter {
    display: flex;
    gap: 6px;
    margin-top: 16px;
    margin-bottom: 4px;
}
.period-btn {
    height: 32px;
    padding: 0 14px;
    border: 1px solid #D0D5DD;
    border-radius: 6px;
    background: #fff;
    color: #444;
    font-size: 13px;
    cursor: pointer;
    transition: all 0.15s;
}
.period-btn:hover {
    background: #EBF4FF;
    border-color: #1A7AFF;
    color: #1A7AFF;
}
.period-btn-on {
    background: #1A7AFF !important;
    border-color: #1A7AFF !important;
    color: #fff !important;
    box-shadow: 0 1px 6px rgba(26,122,255,0.25);
}
/* 차트 블록 */
.chart-block {
    margin-top: 20px;
    background: #FAFBFC;
    border: 1px solid #EAECF0;
    border-radius: 8px;
    padding: 14px 16px;
}
.chart-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 13px;
    font-weight: 600;
    color: #344054;
    margin-bottom: 8px;
}
.chart-legend-note {
    font-size: 11px;
    font-weight: normal;
    color: #888;
    text-align: right;
}
/* 접기/펼치기 버튼 */
.toggle-table-btn {
    width: 100%;
    height: 34px;
    border: 1px solid #D0D5DD;
    border-radius: 6px;
    background: #F8F9FB;
    color: #555;
    font-size: 13px;
    cursor: pointer;
    transition: background 0.15s;
    margin-top: 12px;
}
.toggle-table-btn:hover {
    background: #EBF4FF;
    color: #1A7AFF;
    border-color: #1A7AFF;
}
.font-red { color: #F94848; }
.font-yellow { color: #FFAD09; }
.tb-crud-horizon .history-tr {
    height: 40px;
}
</style>